/**
 * This file specifies the state of the application in response to Bill Payment actions
 */
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { BillPayments } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  billPayments: [],
  billPayment: {},
  count: 0,
});

/**
 * Returns and sets the next state based on the action passed to it
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const billPaymentsReducer = (state = initialState, action) => {
  const { error, billPayments, count, billPayment } = action;
  switch (action.type) {
    case BillPayments.GET_BILL_PAYMENTS:
      return state.set('loading', true);
    case BillPayments.GET_BILL_PAYMENTS_ERROR:
      return state.set('loading', false).set('error', error);
    case BillPayments.GET_BILL_PAYMENTS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('billPayments', fromJS(billPayments))
        .set('count', count);
    case BillPayments.GET_BILL_PAYMENT:
      return state.set('loading', true);
    case BillPayments.GET_BILL_PAYMENT_ERROR:
      return state.set('loading', false).set('error', error);
    case BillPayments.GET_BILL_PAYMENT_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('billPayment', fromJS(billPayment));
    default:
      return state;
  }
};

export default billPaymentsReducer;
